<template>
    <div class="main-container">
        <breadcrumb :list="breadcrumbList" />
        <tl-header type="h3" class="head">FBP Reports</tl-header>
    <toast-message
      :message="errmsg"
      type="error"
      :isToastEnable="toast"
      @close="(val) => toast = val"
    />
    <div class="type">
        <tl-select
        label="FBP Report Type"
        :options="reportType"
        v-model="selectedType"
        @change="(val)=>selectedType=val"
      />
      <tl-select
          v-if="this.selectedType === 'Annual Declared Report'"
          label="Financial Year"
          labelText="name"
          :options="financialYearList"
          v-model="financialYear"
          @change="(val)=>financialYear=val"
        />
        <tl-select
          v-if="this.selectedType === 'Monthly Claim Report'"
          label="Financial Year"
          labelText="name"
          :options="financialYearList"
          v-model="financialYear"
          @change="(val)=>financialYear=val"
        />
    </div>
    <div class="type" v-if="this.selectedType === 'Monthly Claim Report'">
        <tl-select
          label="Month"
          labelText="name"
          :options="monthListForFinancialYear"
          v-model="monthFinancialList"
          @change="(val)=>monthFinancialList=val"
        />
    </div>
    <!-- <div class="type" v-if="this.selectedType === 'Annual Declared Report'">
        <tl-select
          label="Status"
          labelText="name"
          :options="statusList"
          v-model="activeStatus"
          @change="(val)=>activeStatus=val"
        />
    </div> -->
    <bottom-action-container>
        <template slot="end">
          <btn-grp>
            <btn text="Download" type="primary" @click="downloadReport()" />
          </btn-grp>
        </template>
      </bottom-action-container>
    </div>
</template>

<script>
import { mapActions } from 'vuex';
export default{
  data(){
    return{
        breadcrumbList: [
        {
          name: "FBP Reports",
          url: `/dashboard/${this.$route.params.entity_index}/payroll/fbpPayroll`,
        },
        {
          name: "FBP Claimed/Un-Claimed Reports",
          url: `/dashboard/${this.$route.params.entity_index}/utilities/fbpReportDownload`,
        },
      ],
      toast:false,
      errmsg:"",
      financialYearList:[],
      financialYearListOnly:[],
      reportType:["Monthly Claim Report","Annual Declared Report"],
      financialYear:"",
      monthFinancialList:"",
      selectedType:"",
      statusList:["active","exit"],
      activeStatus:"",
      monthListForFinancialYear: [
    { name: "April", value: "apr", index: 3 },
    { name: "May", value: "may", index: 4 },
    { name: "June", value: "jun", index: 5 },
    { name: "July", value: "jul", index: 6 },
    { name: "August", value: "aug", index: 7 },
    { name: "September", value: "sep", index: 8 },
    { name: "October", value: "oct", index: 9 },
    { name: "November", value: "nov", index: 10 },
    { name: "December", value: "dec", index: 11 },
    { name: "January", value: "jan", index: 0 },
    { name: "February", value: "feb", index: 1 },
    { name: "March", value: "mar", index: 2 }
  ]
    }
  },
  computed:{
    le_id() {
      return this.$store.getters["onboard/legal_entities/legal_entity_ID"](
        this.$route.params.entity_index
      );
    },
  },
  mounted(){
   this.generateFinancialYear()
   this.generateFinancialYearOnly()
  },
  methods:{
    ...mapActions({
      downloadClaimedReport:
        "dashboard/payroll/reports/fbpReports/downloadClaimedReport",
        downloadUnClaimedReport:
        "dashboard/payroll/reports/fbpReports/downloadUnClaimedReport",
    }),
    /* function to generate financial year from previous 5 years */
    generateFinancialYear() {
      try {
        let date = new Date();
        let year =
          date.getMonth() > 2 ? date.getFullYear() : date.getFullYear() - 1;
        for (let i = year; i > year - 5; i--) {
          this.financialYearList.push({
            name: i + "-" + (i + 1),
            value: i + ""
          });
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },
    generateFinancialYearOnly() {
      try {
        let date = new Date();
        let year =
          date.getMonth() > 2 ? date.getFullYear() : date.getFullYear();
        for (let i = year; i > year - 5; i--) {
          this.financialYearListOnly.push({
            name: i,
            value: i + ""
          });
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },
    async downloadReport(){
       if(this.selectedType === "Monthly Claim Report"){
        let obj={
            financial_year: this.financialYear.name,
            le_id: this.le_id,
            month:this.monthFinancialList.value
        }
        try{
          let res = await this.downloadClaimedReport(
             obj  
            );
        }
        catch(error){
          this.toast = true;
        this.errmsg = error;
        }
       }
       else{
        let data={
            financial_year: this.financialYear.name,
            le_id: this.le_id,

        }
        try{
        let res = await this.downloadUnClaimedReport(
             data  
            );
          }
        catch(error){
          this.toast = true;
        this.errmsg = error;
        }
       }
     
    },
  }
}
</script>
<style scoped lang="scss">
.head {
  margin-top: 37px;
}
.type {
  display: flex;
  margin-top: 30px;
  div {
    width: 250px;
    padding-right: 20px;
  }
}
</style>